import React from "react";
import Tooltip from "./Tooltip";

const Checkbox = React.forwardRef(
  (
    {
      label,
      checked,
      onChange,
      disabled = false,
      className = "",
      icon = null,
      tooltipContent = null,
      title = null,
      ...props
    },
    ref
  ) => {
    const hasLabel = label !== undefined && label !== null && label !== false && label !== "";
    const layoutClass = hasLabel
      ? "menu-item w-full flex items-center gap-2 justify-start px-3 py-2 select-none focus:outline-none rounded"
      : "inline-flex items-center justify-center select-none";

    const checkboxUi = (
      <label
        className={`
        ${layoutClass}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${className}
      `}
        style={{
          backgroundColor: "transparent",
          transition: "background-color 0.2s ease",
        }}
      >
        <div className="relative flex items-center">
          <input
            ref={ref}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="sr-only"
            {...props}
          />
          <div
            className={`
            w-4 h-4 rounded border-2 transition-all duration-200
            flex items-center justify-center
            ${
              checked
                ? "bg-gray-600 border-gray-600"
                : "bg-transparent border-gray-500 hover:border-gray-400"
            }
            ${disabled ? "opacity-50" : ""}
          `}
          >
            {checked && (
              <svg
                className="w-3 h-3 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
        </div>

        {icon && (
          <span className={`text-base ${checked ? "opacity-100" : "opacity-60"}`}>{icon}</span>
        )}

        {hasLabel ? (
          <span className={`flex-1 text-left ${checked ? "opacity-100" : "opacity-80"}`}>
            {label}
          </span>
        ) : null}
      </label>
    );

    const tooltip = tooltipContent ?? title;
    if (tooltip) {
      return <Tooltip content={tooltip}>{checkboxUi}</Tooltip>;
    }

    return checkboxUi;
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
